import { render, staticRenderFns } from "./Metavendedores.vue?vue&type=template&id=f783e9a4&"
import script from "./Metavendedores.vue?vue&type=script&lang=js&"
export * from "./Metavendedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports